// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search_wrapper__3huWi","input":"search_input__2-Vcn","button":"search_button__3PVbg","icon":"search_icon__3OyVa"};